// extracted by mini-css-extract-plugin
export default {"workersWrapper":"Workers_workersWrapper__9PT1R"};